const checkOtherFiltersValid = (filter, filters) => {
    let othersValid = true;
    for (const filterEntry of Object.values(filters.filters)) {
        if (filterEntry.name !== filter.name) {
            othersValid = othersValid && filterEntry.valid;
        }
    }
    return othersValid;
}

export default checkOtherFiltersValid;
